import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { PlanningGroupDto } from '@digiwall/goliath-documents/proxy';

/**
 * Header content of a free (label) group card: a read-only label. The label is not editable in
 * place — renaming happens through the group's right-click "Edit" entry, which the shell handles
 * via a dialog and persists through the adapter's updateGroup.
 * Specialised group cards (e.g. delivery tours) will replace this per data source in a later step.
 */
@Component({
  selector: 'document-planning-free-group-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: ` <span class="planning-group__label">{{ group().label }}</span> `,
  styles: `
    :host {
      display: block;
      flex: 1 1 auto;
      min-width: 0;
    }
    .planning-group__label {
      display: block;
      font-weight: 600;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  `,
})
export class PlanningFreeGroupCardComponent {
  protected readonly group = input.required<PlanningGroupDto>();
}
